import React from 'react'

import { GAMES_SEARCH_FIELD_NAME } from './constants'
import { SearchIconsContainer, StyledCloseIcon, StyledSearchIcon } from './styles'

interface Props {
  isActive: boolean
  clearSearch: () => void
}

export function Icon({ isActive, clearSearch }: Props) {
  return (
    <>
      <SearchIconsContainer htmlFor={GAMES_SEARCH_FIELD_NAME}>
        <StyledSearchIcon
          data-testid="search"
          isActive={isActive}
        />
      </SearchIconsContainer>

      <StyledCloseIcon
        condition={isActive}
        onClick={clearSearch}
      />
    </>
  )
}
